<template>
    <!-- 出货 -->
    <el-dialog class="wrap" title="出货" :visible.sync="tradeSellDivVisible" :before-close="trade_sell_dialog_close" v-loading="loading" append-to-body
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="itembg" v-if="null != pocketItems">
                <div id="itemtitle">
                    背包中的道具（{{pocketItems.length}}/{{POCKET_VOLUME}}）
                </div>
                <div id="itemlist">
                    <div v-for="(item,index) in pocketItems" v-bind:key="index" ref="item" class="itemdiv" :id="item.itemId + '_item'">
                        <input name="items" :id="item.itemId" type="radio" :value="item" v-model="selecteditem"/>
                        <label :for="item.itemId">
                            <img :class="{ 'img-spoiled': item.state === 'spoiled' }" :title="imgTitle(item)"
                            :src="ossPath + item.imgSrc">
                            <div v-if="item.stackCount>1" class="stackCount" v-text="item.stackCount"/>
                            <!-- 保鲜（perish_v1）：变质/临期角标（交易行挂单列表与行内一致） -->
                            <div v-if="item.state === 'spoiled'" class="freshness-badge spoiled">已变质</div>
                            <div v-else-if="item.state === 'expiring' && item.expireAt" class="freshness-badge expiring">{{ freshRemainText(item) }}</div>
                        </label>
                    </div>
                </div>
                <div id="itemContent">
                    <div class="noSelected" v-if="null == selecteditem">
                        请选择背包中的道具
                    </div>
                    <div class="iteminfo" v-else>
                        <div class="infoline"><img :title="selecteditem.itemName" :src="ossPath + selecteditem.imgSrc"></div>
                        <div class="infoline" v-if="null!=selecteditem.itemName && ''!=selecteditem.itemName"><label>名称：</label><span>{{selecteditem.itemName}}</span></div>
                        <div class="infoline" v-if="selecteditem.state === 'spoiled'" style="color:#999;"><label>状态：</label><span>已变质，不可食用</span></div>
                        <div class="infoline" v-if="null!=selecteditem.score && -1!=selecteditem.score"><label>评分：</label><span>{{selecteditem.score}}</span></div>
                        <div class="infoline" v-if="null!=selecteditem.strength && -1!=selecteditem.strength"><label>体力恢复：</label><span>{{selecteditem.strength}}</span></div>
                        <div class="infoline" v-if="null!=selecteditem.capacity && -1!=selecteditem.capacity"><label>容量：</label><span>{{selecteditem.capacity}}</span></div>
                        <div class="infoline" v-if="null!=selecteditem.durability && -1!=selecteditem.durability"><label>耐久度：</label><span>{{selecteditem.durability}}</span></div>
                        <div class="infoline" v-if="null!=selecteditem.price && -1!=selecteditem.price"><label>大车轮收购价：</label><span>{{selecteditem.price}}</span></div>
                        <div class="infoline">
                            <label>数量：</label>
                            <input type="number" id="sellCount" v-model="sellCount" min="1" :max="selecteditem.stackCount" :disabled="selecteditem.stackCount <= 1" style="width:70px;"/>
                            <span v-if="selecteditem.stackCount > 1" style="color:#888;">（最多 {{selecteditem.stackCount}}）</span>
                        </div>
                        <div class="infoline">
                            <label>单价：</label>
                            <input type="text" id="unitPrice" v-model="unitPrice"/>
                        </div>
                        <div class="infoline">
                            <label>总价：</label>
                            <span id="price" v-html="price"/>
                            <!-- <input type="text" id="price" v-model="price"/> -->
                        </div>
                        <div class="infoline">
                            <label>出售时长：</label>
                            <select id="sellHours" v-model="sellHours">
                                <option value="4">4小时</option>
                                <option value="8">8小时</option>
                                <option value="12">12小时</option>
                                <option value="24">24小时</option>
                            </select>
                        </div>
                        <el-button type="success" icon="el-icon-check" :disabled="selecteditem.state === 'spoiled'" @click="sellItem(selecteditem.itemId);">出售</el-button>
                    </div>
                </div>
            </div>
            <div class="noItems" v-if="null == pocketItems">
                暂无道具，快去收集些吧
            </div>
        </el-dialog>
</template>

<script>
import {postRequest} from '../../utils/api'
import {getRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'tradeSell',
  props:{
    tradeSellDivVisible: {
      type: Boolean,
      default: false
    },
    fantasyUserBO: Object,
  },
  data() {
    return {
        selecteditem: null, // 双向绑定checkbox数据数组
        pocketItems: null,
        unitPrice: 0,
        price: 0,
        sellCount: 1,
        sellHours: 12,
        loading: false
    };
  },
  watch: {
      selecteditem: {
        handler(newVal, oldVal){
            if (newVal != null) {
              this.selecteditem = newVal;
              // 默认按整栈数量挂单，可自行改小
              this.sellCount = (newVal.stackCount && newVal.stackCount > 0) ? newVal.stackCount : 1;
            }
            this.unitPrice = 0;
        }
      },
      unitPrice: {
        handler(newVal, oldVal){
            if (newVal != null) {
            this.unitPrice = newVal;
            this.recalcPrice();
          }
        }
      },
      sellCount: {
        handler(newVal, oldVal){
            if (newVal != null) {
            this.recalcPrice();
          }
        }
      },
      price: {
        handler(newVal, oldVal){
            if (newVal != null) {
            this.price = newVal;
          }
        }
      },
      sellHours: {
        handler(newVal, oldVal){
            if (newVal != null) {
            this.sellHours = newVal;
          }
        }
      },
      tradeSellDivVisible: {
        handler(newVal) {
          if (newVal === true) {
            this.getTradeSellItems();
          }
        }
      }
  },
  mounted: function () {
      if (this.tradeSellDivVisible) {
          this.getTradeSellItems();
      }
  },
  methods: {
    trade_sell_dialog_close(){
      this.$emit("trade_sell_dialog_close");
    },
    // 保鲜（perish_v1）：临期剩余文案（与 FantasyItemCard 口径一致）
    freshRemainText(item) {
      const remain = item.expireAt - Date.now();
      if (remain >= 86400000) return '剩' + Math.ceil(remain / 86400000) + '天';
      return '剩' + Math.max(1, Math.floor(remain / 3600000)) + '小时';
    },
    // 总价 = 单价 × 挂单数量
    recalcPrice() {
      if (this.selecteditem != null) {
        const count = parseInt(this.sellCount, 10);
        this.price = (isNaN(count) ? 0 : count) * this.unitPrice;
      }
    },
    // 悬停标题：只拼接实际存在的属性，避免 null 值拼出"耐久：null"之类
    imgTitle(item) {
      let t = item.itemName || '';
      if (item.strength != null && item.strength > -1) {
        t += ' 体力：' + item.strength;
      } else if (item.durability != null && item.durability > -1) {
        if (item.score != null && item.score > -1) {
          t += ' 评分：' + item.score;
        }
        t += ' 耐久：' + item.durability;
      } else if (item.score != null && item.score > -1) {
        t += ' 评分：' + item.score;
      }
      return t;
    },
    //获取背包道具
    getTradeSellItems: function(){
        this.pocketItems = null;
        this.selecteditem = null;
        this.unitPrice = 0;
        this.price = 0;
        //this.sellHours = 4;
        this.loading = true;
        getRequest('/item/cabinet/openPocket', {
        }).then(resp=> {
          this.loading = false;
          if (resp.status == 200) {
            //成功
            const respData = resp.data;
            if (200 == respData.status) {
              if (null != respData.data) {
                // 绑定道具（bind_flag=1，如澡票）不可上架，后端 sellItem 同样硬拦
                // 已变质道具不再出现在出货列表（后端 sellItem 也会拒绝上架，这里直接不给选）
                this.pocketItems = (respData.data.pocketItems || []).filter(i => i.bindFlag != 1 && i.state !== 'spoiled');
              } else {
                this.pocketItems = null;
              }
            } else {
              Message.warning(respData.message);
            }
          } else {
            //失败
            Message.error('获取背包道具失败');
          }
        }, resp=> {
          Message.error('获取背包道具异常');
        });
    },
    //卖出道具
    sellItem: function(itemId){
        let _this = this;
        // 数量校验：不合法直接提示，不静默改值
        const count = parseInt(this.sellCount, 10);
        if (isNaN(count) || count < 1) {
          Message.error('出货数量不能小于 1');
          return;
        }
        if (this.selecteditem != null && count > this.selecteditem.stackCount) {
          Message.error('出货数量不能超过持有数量（现 ' + this.selecteditem.stackCount + ' 个）');
          return;
        }
        this.sellCount = count;
        this.recalcPrice();
        if (0 == this.price) {
          Message.success("请输入出售单价");
          return;
        }
        this.$confirm('您确定要以单价 ' + this.unitPrice + ' 挂单出售 ' + count + ' 个吗?无论是否交易成功，均会收取售价1%的挂单费。', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            _this.loading = true;
            postRequest('/map/tradeCenter/sellItem', {
                centerId: 1,
                itemId: itemId,
                stackCount: count,
                price: _this.price,
                sellHours: _this.sellHours
            }).then(resp=> {
                if (resp.status == 200) {
                    //成功
                    const respData = resp.data;
                    if (200 == respData.status) {
                      Message.success("挂单成功！");
                      _this.getTradeSellItems();
                    } else {
                      _this.loading = false;
					            Message.error(respData.message);
                    }
                } else {
                    //失败
                    _this.loading = false;
                    Message.error('用户非法⊙﹏⊙∥!');
                }
            }, resp=> {
                _this.loading = false;
                Message.error('用户非法⊙﹏⊙∥!');
            });
        }, function () {
            //取消
        })
    },
  }
}
</script>

<style scoped>
.wrap {
    margin:auto;
}
.itembg {
    width:100%;
    height: 500px;
}
#itemtitle {
	padding:3px 5px;
	background-color:#72b653;
	font-size:16px;
	font-weight:bold;
	color:#fff;
	letter-spacing:5px;
	text-align:center;
}
#itemlist {
	text-align:center;
    width: 52%;
    height:100%;
    overflow-y:scroll;
	float:left;
}
#itemContent {
    width: 48%;
	float:left;
}
.itemdiv {
	height:80px;
	width:70px;
	float:left;
	position:relative;
	margin:5px;
}
.itemdiv input {
	position:absolute;
	top:0;
	left:0;
}
.itemdiv img {
	height:40px;
}
.itemdiv .stackCount {
  position: absolute;
  bottom: 20px;
  font-size: 0.7em;
  width: 100%;
  /* background-color: rgba(233, 141, 66, 0.4); */
}
/* ---- 保鲜（perish_v1）：与 FantasyItemCard 同款变质/临期角标 ---- */
.img-spoiled {
  filter: grayscale(1);
  opacity: 0.75;
}
.freshness-badge {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 0.72em;
  padding: 0 3px;
  border-radius: 0 0 0 4px;
  line-height: 1.4;
  color: #fff;
  font-weight: bold;
  text-shadow: 1px 1px 1px rgba(0,0,0,0.3);
}
.freshness-badge.expiring {
  background-color: #ff9800;
}
.freshness-badge.spoiled {
  background-color: #8d8d8d;
}
/* 无道具时，提示语显示的样式 */
.noItems, .noSelected {
	padding:3px 5px;
	font-size:16px;
	font-weight:bold;
	letter-spacing:5px;
	text-align:center;
    height: 100px;
    line-height: 100px;
}

.iteminfo .infoline {
	height: 40px;
    line-height: 40px;
    vertical-align:middle;
    margin: 5px;
}
.iteminfo .infoline img {
	height: 40px;
    width: 40px;
    line-height: 40px;
    vertical-align:middle;
}

/* ========== 移动端适配 ========== */
@media screen and (max-width: 768px) {
  .itembg {
    height: auto;
    min-height: 0;
  }
  /* 左右分栏改为上下堆叠 */
  #itemlist {
    width: 100%;
    float: none;
    height: auto;
    /* 道具多时限高内部滚动：按「4 行」定死像素（5 列 × 62px + 3 道 6px 间距 + 上下 padding = 280px），
       19~20 个道具刚好完整显示 4 行不被裁切；更多时在区域内滚动，
       保证下方详情与「出售」按钮不用翻页就能看到 */
    max-height: 280px;
    align-content: start;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    /* float 布局换 grid：间距统一，不再是挤在一起的小方块 */
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 6px;
    padding: 6px 2px 8px;
    box-sizing: border-box;
  }
  #itemContent {
    width: 100%;
    float: none;
    clear: both;
    border-top: 1px solid #ddd;
    padding-top: 8px;
  }
  /* 道具格子：统一尺寸 + 选中描边 */
  .itemdiv {
    height: 62px;
    width: auto;
    float: none;
    margin: 0;
    padding: 13px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fffdf0;
    border: 1px solid #e8e2bd;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .itemdiv input {
    top: 2px;
    left: 2px;
    transform: scale(0.85);
    transform-origin: top left;
    margin: 0;
  }
  .itemdiv img {
    display: block; /* 去掉 inline 图片的基线空隙，否则格子高度会多出 5px */
    height: 36px;
    width: 36px;
    object-fit: contain;
  }
  .itemdiv input:checked + label {
    outline: 2px solid #72b653;
    outline-offset: 2px;
    border-radius: 6px;
  }
  .itemdiv .stackCount {
    position: absolute;
    bottom: 1px;
    left: 0;
    font-size: 11px;
    color: #333;
  }
  .freshness-badge {
    font-size: 10px;
    padding: 0 2px;
    line-height: 1.3;
  }
  /* 详情区：标签定宽 + 输入框对齐，不再一行行错落 */
  .iteminfo .infoline {
    height: auto;
    line-height: 1.6;
    margin: 5px 0;
    font-size: 13px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }
  .iteminfo .infoline label {
    flex: 0 0 96px;
    color: #666;
    white-space: nowrap;
  }
  .iteminfo .infoline img {
    height: 32px;
    width: 32px;
  }
  /* 首行只有图标，压紧高度，别白占一行 */
  .iteminfo .infoline:first-child {
    margin: 0 0 2px;
  }
  .iteminfo .infoline:first-child img {
    height: 28px;
    width: 28px;
  }
  .iteminfo .infoline input,
  .iteminfo .infoline select {
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    padding: 0 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  #sellCount {
    width: 80px !important;
  }
  #unitPrice {
    width: 110px;
  }
  #sellHours {
    width: 120px;
  }
  .iteminfo .infoline #price {
    font-weight: bold;
    color: #c62828;
  }
  /* 出售按钮：整行宽，放在详情末尾（不吸底：吸底会盖住「出售时长」一行） */
  .iteminfo .el-button {
    width: 100%;
    margin: 10px 0 2px;
    height: 38px;
  }
  .noSelected, .noItems {
    height: 60px;
    line-height: 60px;
    font-size: 14px;
  }
}
</style>